import { Area } from "common/interfaces/Area";
import { getJsonAddressMasters } from "./common";

export const getAreas = (
  prefCode: string,
  cityCode: string,
  forAnonymous: boolean
) => getJsonAddressMasters<Area>(`${prefCode}/areas/${cityCode}`, forAnonymous);
